import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import {
  inputSearchTerm,
  loadMore,
  openPage,
  performSearch,
  selectLastViewedChannel,
  selectRootChannel,
  selectSubscribedChannel,
} from './newsfeed-page.actions';

import { getSearchTermFragment } from './newsfeed-page.selectors';

@Injectable()
export class NewsfeedPageFacade {
  searchTermFragment$ = this.store.pipe(select(getSearchTermFragment));

  constructor(private readonly store: Store) {}

  openPage(): void {
    this.store.dispatch(openPage());
  }

  loadMore(): void {
    this.store.dispatch(loadMore());
  }

  inputSearchTerm(searchTermFragment: string): void {
    this.store.dispatch(inputSearchTerm({ searchTermFragment }));
  }

  performSearch(): void {
    this.store.dispatch(performSearch());
  }

  selectRootChannel(): void {
    this.store.dispatch(selectRootChannel());
  }

  selectSubscribedChannel(id: string, fairId: string): void {
    this.store.dispatch(selectSubscribedChannel({ id, fairId }));
  }

  selectLastViewedChannel(): void {
    this.store.dispatch(selectLastViewedChannel());
  }
}
